// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__ZfkFb","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__3pNMh"};